import APIRequest from '~/lib/api_request';

const checkIfVideoLimitExceeded = async (videosCount) => {
  try {
    const response = await APIRequest.get({
      resource: '/v1/videos/videos_limit',
      data:     { videos_count: videosCount },
    });

    const { body } = response;

    return body;
  } catch (error) {
    console.error('Error checking if limit exceeded', error);
    return false;
  }
};

export { checkIfVideoLimitExceeded };
